import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
} from '@mui/material';
import { useEffect, useState } from 'react';

export default function NestedListItem(props) {
  const [open, setOpen] = useState(false);

  // Auto-open if the currently selected route is reachable from this expander.
  // Walks descendants recursively so 3-level admin groups open correctly when a
  // grandchild is active (not just an immediate child).
  useEffect(() => {
    const hasSelectedDescendant = (children) =>
      Array.isArray(children) &&
      children.some(
        (child) =>
          child.id === props.selectedIndex ||
          hasSelectedDescendant(child.children),
      );
    if (hasSelectedDescendant(props.item.children)) {
      setOpen(true);
    }
  }, [props.selectedIndex, props.item.children]);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <ListItem
      className="MuiListItem-root .MuiButtonBase-root"
      key={props.index}
      sx={{ display: 'block', padding: '0!important' }}
    >
      <ListItemButton
        key={props.index}
        data-testid={props.item.testId}
        component="a" //need to use an anchor tag for this to render properly.  Omitting the href will cause a button to not render properly.
        selected={props.isSelected}
        onClick={handleClick}
        sx={{
          '&.Mui-selected': {
            borderLeft: '3px solid #1976d2',
            borderLeftWidth: '2px',
          },
          '&.Mui-focusVisible': {
            backgroundColor: '#1c8cfd',
          },
          ':hover': {
            backgroundColor: '#4da6ff',
          },
        }}
      >
        <ListItemIcon className="MuiSvgIcon-root">
          {props.item.icon}
        </ListItemIcon>

        {!props.isAdmin ? (
          open ? (
            <ExpandLess />
          ) : (
            <ExpandMore />
          )
        ) : open ? (
          <ExpandMore />
        ) : (
          <ExpandLess />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {props.children}
      </Collapse>
    </ListItem>
  );
}
